import 'babel-polyfill';
import fileApi from './api/fileApi';
import 'raygun4js';
import 'custom-event-polyfill';
import apDefaults from './globalConfig/ap.config.defaults';

let storageCheckAttempt = 0;
let storageCheckAttemptThreshold = 6;
let storgeCheckAttemptInterval = 300;

function storageCheckLoop() {
  console.log(`Storage check attempt: ${storageCheckAttempt + 1}`);
  console.log(`Session storage length: ${sessionStorage.length}`);
  if (storageCheckAttempt < storageCheckAttemptThreshold && sessionStorage.length === 0) {
    localStorage.setItem('getSessionStorage', Date.now());
    storageCheckAttempt++;
    setTimeout(storageCheckLoop, storgeCheckAttemptInterval);
  }
  else {
    // retrieve academy settings
    console.log(`Retrieving Academy settings`);
    fileApi.getAcademySettings().then((settings) => {
      const apConfig = { ...apDefaults, ...settings };
      window.__academySettings = apConfig; // put the global settings as window variables for global consumption across all files.
      window.__translationsLoaded = false;

      // setup raygun
      if (window.__academySettings.VUE_APP_RAYGUN_API_KEY != "") {
        rg4js('apiKey', window.__academySettings.VUE_APP_RAYGUN_API_KEY);
        rg4js('enableCrashReporting', window.__academySettings.VUE_APP_RAYGUN_ENABLE_CRASHREPORTING);
        rg4js('enablePulse', window.__academySettings.VUE_APP_RAYGUN_ENABLE_PULSE);
      }
      // make sure academy settings is loaded before calling the mount function.
      import("./appMounter").then((appMounter) => {

        console.log('Mounting application');
        appMounter.mount();
      });
    }).catch(() => {
      // at this point vue is not yet loaded, we can only use native alert.
      alert("ap.config.json not found in root directory!!!");
    });
  }
}

storageCheckLoop();
